import React, { useCallback } from "react";
import SVG from "react-inlinesvg";
import Modal from "react-modal";

import LeftURL from "@assets/icons/left.svg";

interface FullLayoutModalProps {
  isOpen: boolean;
  title: string;
  subTitle: string;
  closeModal?: () => void;
  children: React.ReactElement | React.ReactElement[];
  hideHeaderBackButton?: boolean;
}

Modal.setAppElement("body");

export const FullLayoutModal = ({
  isOpen,
  title,
  subTitle,
  children,
  closeModal,
  hideHeaderBackButton,
}: FullLayoutModalProps): JSX.Element => {
  const customStyles = {
    content: {
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      padding: "0",
    },
  };

  const renderBackButton = useCallback(() => {
    if (hideHeaderBackButton) return;

    return (
      <div className='flex items-center text-primary-900'>
        <SVG
          src={LeftURL}
          className='icon-lg fill-current mr-4 cursor-pointer'
          onClick={closeModal}
        />
        <div>
          <p className='h6 font-bold md:h3'>{title}</p>
          <div className='mt-2'>{subTitle}</div>
        </div>
      </div>
    );
  }, [hideHeaderBackButton]);
  return (
    <Modal isOpen={isOpen} style={customStyles}>
      <section className='meander text-legacyColor-neutral-1-800'>
        <header>
          <div className='flex items-center mx-[0.938rem] py-[1.813rem] md:mx-[7.625rem] md:pb-8 md:pt-[3.18rem]'>
            {renderBackButton()}
          </div>
        </header>
        <main className='mx-[0.938rem] md:mx-[7.625rem]'>{children}</main>
      </section>
    </Modal>
  );
};
